import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';
import {BWCMessaging} from '../BWCMessaging/BWCMessaging';
import CancelTripModalRefund from '../CancelTripModalRefund/CancelTripModalRefund';
import CancelTripModalRefundConfirmation from '../CancelTripModalRefundConfirmation/CancelTripModalRefundConfirmation';
import {CancelTripModalCategories} from '../CancelTripModalCategories/CancelTripModalCategories';
import {CancelTripModalForm} from '../CancelTripModalForm/CancelTripModalForm';
import {CancelTripModalReasons} from '../CancelTripModalReasons/CancelTripModalReasons';
import CancelTripModalRefundRequestCancellation from '../CancelTripModalRefundRequestCancellation/CancelTripModalRefundRequestCancellation';
import {CancelTripModalConfirmation} from '../CancelTripModalConfirmation/CancelTripModalConfirmation';
import translate from '../../../../../../utils/translations';

export default class AutoCancellation extends Component {
    static propTypes = {
        autoCancellationSummary: PropTypes.shape({
            continueLabel: PropTypes.string,
            message: PropTypes.string,
            title: PropTypes.string,
            vasMessage: PropTypes.string,
        }),
        cancellationReasonsByCategory: PropTypes.arrayOf(PropTypes.shape({})),
        category: PropTypes.shape({}),
        errorMessage: PropTypes.string,
        errorTitle: PropTypes.string,
        goBack: PropTypes.func,
        hasError: PropTypes.bool,
        location: PropTypes.string,
        message: PropTypes.string,
        onFormChange: PropTypes.func,
        onSelectCategory: PropTypes.func,
        onSelectReason: PropTypes.func,
        priceDetails: PropTypes.shape({}),
        reason: PropTypes.shape({}),
        recommendedListings: PropTypes.arrayOf(PropTypes.shape({})),
        refundEmailMessage: PropTypes.string,
        refundMessage: PropTypes.string,
        refundTitle: PropTypes.string,
        responseCode: PropTypes.string,
        shortDisplayName: PropTypes.string,
        showsBookWithConfidenceMessage: PropTypes.bool,
        showsTravelerModificationFlow: PropTypes.bool,
        step: PropTypes.number,
        translations: PropTypes.shape({}),
        travelerModificationError: PropTypes.shape({}),
        travelerModificationSubmitted: PropTypes.bool,
    };

    static defaultProps = {
        category: {
            descriptionText: '',
            text: '',
        },
        priceDetails: {
            vasItems: null,
        },
        reason: {
            text: '',
        },
        step: 0,
        translations: {},
    };

    state = {
        hasRefundFailed: false,
    };

    componentDidUpdate(prevProps) {
        /* REFUND_FAILED interrupts the flow. Since we cannot predict it we have to insert
        a new modal in the middle */
        if (
            this.props.responseCode === 'REFUND_FAILED' &&
            !prevProps.responseCode
        ) {
            this.setState({hasRefundFailed: true});
        }
    }

    renderModalSteps = () => {
        const {
            autoCancellationSummary,
            cancellationReasonsByCategory,
            category,
            errorMessage,
            errorTitle,
            goBack,
            hasError,
            location,
            message,
            onClose,
            onDone,
            onFormChange,
            onSelectCategory,
            onSelectReason,
            priceDetails,
            reason,
            recommendedListings,
            requestMarker,
            refundFailedSummary,
            refundEmailMessage,
            refundMessage,
            refundTitle,
            responseCode,
            shortDisplayName,
            showsBookWithConfidenceMessage,
            showsTravelerModificationFlow,
            translations,
            travelerModificationError,
            travelerModificationSubmitted,
        } = this.props;
        const hasPropertyDamageProtection =
            priceDetails &&
            Array.isArray(priceDetails.lineItems) &&
            priceDetails.lineItems.some(
                (item) => item.type === 'PROPERTY_DAMAGE_PROTECTION'
            );
        const showVasMessage = !!(
            get(priceDetails, 'vasItems', null) || hasPropertyDamageProtection
        );
        let steps = [];

        steps.push(
            <CancelTripModalRefund
                {...autoCancellationSummary}
                key={'CancelTripModalRefund'}
                showVasMessage={showVasMessage}
            />
        );
        steps.push(
            <CancelTripModalCategories
                cancellationReasonsByCategory={cancellationReasonsByCategory}
                disclaimer={translate(
                    translations,
                    'trav-dash/trav-home',
                    'messages',
                    'th.inbox.conversation.cancel.modal.text.autoCancellationDisclaimer'
                )}
                isWithdraw={false}
                key={'CancelTripModalCategories'}
                onSelectCategory={onSelectCategory}
                title={this.props.manageBookingLabel}
                translations={translations}
            />
        );
        steps.push(
            <CancelTripModalReasons
                key={'CancelTripModalReasons'}
                category={category.category}
                onSelectReason={onSelectReason}
                reasons={category.reasons}
                title={category.text}
                description={category.descriptionText}
            />
        );

        if (showsBookWithConfidenceMessage) {
            steps.push(
                <BWCMessaging
                    key={'BWCMessaging'}
                    translations={translations}
                />
            );
        }

        steps.push(
            <CancelTripModalForm
                description={reason.text}
                goBack={goBack}
                key={'CancelTripModalForm'}
                onChange={onFormChange}
                onClose={onClose}
                reason={reason}
                shortDisplayName={shortDisplayName}
                showsTravelerModificationFlow={showsTravelerModificationFlow}
                title={category.text}
                translations={translations}
                travelerModificationError={travelerModificationError}
                travelerModificationSubmitted={travelerModificationSubmitted}
                value={message}
            />
        );

        if (this.state.hasRefundFailed) {
            steps.push(
                <CancelTripModalRefundRequestCancellation
                    {...refundFailedSummary}
                />
            );
        }

        if (responseCode === 'CANCELLATION_PENDING_APPROVAL') {
            steps.push(
                <CancelTripModalConfirmation
                    key={'CancelTripModalConfirmation'}
                    hasError={hasError}
                    onClose={onDone}
                    text={errorMessage}
                    title={errorTitle}
                    translations={translations}
                />
            );
        } else {
            steps.push(
                <CancelTripModalRefundConfirmation
                    errorMessage={errorMessage}
                    errorTitle={errorTitle}
                    hasError={hasError}
                    key={'CancelTripModalRefundConfirmation'}
                    location={location}
                    requestMarker={requestMarker}
                    recommendedListings={recommendedListings}
                    refundEmailMessage={refundEmailMessage}
                    refundMessage={refundMessage}
                    refundTitle={refundTitle}
                    translations={translations}
                />
            );
        }

        return steps;
    };

    render() {
        const {step} = this.props;
        return this.renderModalSteps()[step];
    }
}
